import { WhatsappLogo, EnvelopeSimple, Clock, LinkSimple } from "@phosphor-icons/react";
import { Seo } from "@/components/Seo";
import { Footer } from "@/components/Footer";
import { LeadForm } from "@/components/LeadForm";
import { useSiteInfo, waLink, track } from "@/lib/site";

export default function Contact() {
  const info = useSiteInfo();
  return (
    <>
      <Seo title="Contact" path="/contact" description="Get in touch with Avinya Bookings — WhatsApp, email and support hours." />
      <div className="px-4 py-8 md:px-6">
        <div className="mx-auto max-w-4xl">
          <h1 className="font-heading text-3xl font-bold text-stone-900 md:text-4xl">Contact Avinya Bookings</h1>
          <p className="mt-2 text-stone-600">We're here to help you find and book the perfect venue.</p>
          <div className="mt-8 grid gap-8 md:grid-cols-2">
            <div className="space-y-4">
              {info.support_whatsapp && (
                <a data-testid="contact-whatsapp" href={waLink(info.support_whatsapp, "Hi Avinya Bookings, I need help.")} target="_blank" rel="noreferrer" onClick={() => track("whatsapp_clicked", { source: "contact" })} className="flex items-center gap-3 rounded-2xl border border-stone-200 bg-white p-4 hover:bg-accent">
                  <WhatsappLogo size={26} weight="fill" className="text-green-600" />
                  <div><p className="font-heading font-semibold">Chat on WhatsApp</p><p className="text-sm text-stone-500">+{String(info.support_whatsapp).replace(/[^0-9]/g, "")}</p></div>
                </a>
              )}
              {info.support_email && (
                <a href={`mailto:${info.support_email}`} className="flex items-center gap-3 rounded-2xl border border-stone-200 bg-white p-4 hover:bg-accent">
                  <EnvelopeSimple size={26} className="text-primary" />
                  <div><p className="font-heading font-semibold">Email us</p><p className="text-sm text-stone-500">{info.support_email}</p></div>
                </a>
              )}
              {info.business_hours && (
                <div className="flex items-center gap-3 rounded-2xl border border-stone-200 bg-white p-4">
                  <Clock size={26} className="text-primary" />
                  <div><p className="font-heading font-semibold">Business hours</p><p className="text-sm text-stone-500">{info.business_hours}</p></div>
                </div>
              )}
              {info.razorpay_link && (
                <a data-testid="contact-razorpay-link" href={info.razorpay_link} target="_blank" rel="noreferrer" onClick={() => track("razorpay_link_clicked", { source: "contact" })} className="flex items-center gap-3 rounded-2xl border border-stone-200 bg-white p-4 hover:bg-accent">
                  <LinkSimple size={26} className="text-primary" />
                  <div><p className="font-heading font-semibold">Pay securely online</p><p className="text-sm text-stone-500">Pay via our Razorpay link (UPI / Cards)</p></div>
                </a>
              )}
            </div>
            <div className="rounded-2xl border border-stone-200 bg-white p-5">
              <p className="font-heading text-lg font-semibold">Send us a message</p>
              <p className="mb-4 text-sm text-stone-500">Tell us what you're looking for and we'll get back to you.</p>
              <LeadForm />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
